// src/controllers/landingPageController.js
import { supabase } from '../supabaseClient';

export const saveLead = async (email, feature) => {
  try {
    const { data, error } = await supabase
      .from('waiting_list')
      .insert([
        { 
          email: email,
          waited_feature: feature
        }
      ]);

    return { data, error };
  } catch (error) {
    throw error;
  }
};

export const saveExpertRequest = async (email, phone, feature) => {
  try {
    const { data, error } = await supabase
      .from('waiting_list')
      .insert([
        { 
          email: email,
          phone: phone,
          waited_feature: feature
        }
      ]);

    return { data, error };
  } catch (error) {
    throw error;
  }
};